import { AddHelperBox } from "components/AddHelperBox/AddHelperBox"
import { TakeDurationBox } from "components/TakeDurationBox/TakeDurationBox"
import { TakeNoteBox } from "components/TakeNoteBox/TakeNoteBox"

import { TestData } from "graphql/types"

type AddHelperProps = {
  data: TestData
  setData: (data: TestData) => void
}

export const AddHelper = (props: AddHelperProps) => {
  const { data, setData } = props

  return (
    <>
      <TakeNoteBox data={data} setData={setData} name="Hilfskräfte" />
      <AddHelperBox data={data} setData={setData} />
      <TakeDurationBox data={data} setData={setData} />
    </>
  )
}
